import { isDateStringEmpty, isValidDate } from '../../../sharedComponents/dateHelper';
import { isBefore } from 'date-fns';
import { ValidationResult } from '../../../sharedComponents/validationResult.type';
import { assertExhaustive } from '../../../../../utils';

export type ServiceOrderDateField = 'startedAt' | 'completedAt';
export type DateParseErrors = Record<ServiceOrderDateField, boolean>;
export const initialDateParseErrors: DateParseErrors = {
    startedAt: false,
    completedAt: false,
};

export type ServiceOrderFormFieldError<T> = { type: T };
export type ExecutionDateErrorType = 'dateInFuture' | 'endDateBeforeStartDateError' | 'removedDate' | 'oneMandatory';

export const validateStartedAt = (
    formStateStartedAt: Date | undefined,
    previousStartedAt: Date | undefined,
): ServiceOrderFormFieldError<ExecutionDateErrorType> | undefined => {
    if (isDateStringEmpty(formStateStartedAt) && previousStartedAt !== undefined) {
        return { type: 'removedDate' };
    }

    return undefined;
};

export const validateCompletedAt = (
    startedAtFormValue: Date | undefined,
    completedAtFormValue: Date | undefined,
    isCompleted: boolean,
): ServiceOrderFormFieldError<ExecutionDateErrorType> | undefined => {
    const startedAtIsEmpty = isDateStringEmpty(startedAtFormValue);
    const completedAtIsEmpty = isDateStringEmpty(completedAtFormValue);

    if (isCompleted && completedAtIsEmpty) {
        return { type: 'removedDate' };
    }

    if (startedAtIsEmpty && completedAtIsEmpty) {
        return { type: 'oneMandatory' };
    }

    if (completedAtFormValue === undefined) {
        return undefined;
    }

    if (completedAtFormValue > new Date()) {
        return { type: 'dateInFuture' };
    }

    if (isValidDate(startedAtFormValue) && isBefore(completedAtFormValue, startedAtFormValue)) {
        return { type: 'endDateBeforeStartDateError' };
    }

    return undefined;
};

export const getDateValidation = (
    error: ServiceOrderFormFieldError<ExecutionDateErrorType> | undefined,
): ValidationResult => {
    if (error === undefined) {
        return { error: undefined, warning: undefined };
    }

    switch (error.type) {
        case 'dateInFuture':
            return {
                error: 'outboundPortal.serviceOrder.sidebar.executionDate.inTheFuture',
                warning: undefined,
            };
        case 'endDateBeforeStartDateError':
            return {
                error: 'outboundPortal.serviceOrder.sidebar.executionDate.endDateBeforeStartDateError',
                warning: undefined,
            };
        case 'removedDate':
            return {
                error: 'outboundPortal.serviceOrder.sidebar.executionDate.removedDate',
                warning: undefined,
            };
        case 'oneMandatory':
            return {
                error: 'outboundPortal.serviceOrder.sidebar.executionDate.oneMandatory',
                warning: undefined,
            };
        default:
            return assertExhaustive(error.type);
    }
};
